export default __webpack_public_path__ + "static/media/app-stats-dark.c6ae160e.png";